import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ProdottoType } from '@next-nx/utils/types'
import { useTrans } from '@next-nx/hooks'
import { getIcon } from '@next-nx/utils/icons'
import { TabGroup } from '@next-nx/shared-ui/atoms'
import { TabTriggerCard } from '@next-nx/shared-ui/molecules'
import { PreventivatoreIntro } from '@next-nx/shared-ui/organisms'
import styles from './PreventivatoreHomeSection.module.sass'


interface Props {
  prodotti: ProdottoType[]
  setProdottoPreventivatoreModal: (p: ProdottoType) => void
  selectedLineePreventivatore: number[]
  setSelectedLineePreventivatore: (linee_ids: number[]) => void
  className?: string
}

const PreventivatoreHomeSection = (props: Props) => {

  const { 
    prodotti = [],
    setProdottoPreventivatoreModal = () => undefined,
    selectedLineePreventivatore = [],
    setSelectedLineePreventivatore = () => undefined,
    className = '',
  } = props

  const t = useTrans()
  
  const tabs = prodotti.map(p => ({ 
    key: `prodotto_${p.pk}`, 
    label: p.titolo,
    icon: getIcon(p.icon),
    content: (
      <PreventivatoreIntro 
        title={t("Consulta il nostro <strong>preventivatore</strong>")}
        ctaLabel={t("Richiedi un preventivo personalizzato")}
        prodotto={p} 
        setFormModalOpen={() => setProdottoPreventivatoreModal(p)}
        selectedLinee={selectedLineePreventivatore}
        setSelectedLinee={(linee_ids) => setSelectedLineePreventivatore(linee_ids)}
        className={styles.tabContent}
      />
    )
  }))

  return (
    <div
      className={`${styles.preventivatoreHomeSection} ${
        className ? ` ${className}` : ''
      }`}
    >
      <div className={styles.tabs}>
        <TabGroup 
          tabs={tabs} 
          clearSelectedLineePreventivatore={() => setSelectedLineePreventivatore([])}
        />
      </div>
      <div className={styles.slider}>
        <div
          className={styles.titleMobile}
          dangerouslySetInnerHTML={{
            __html: t('Consulta il nostro <strong>preventivatore</strong>'),
          }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView={1.5}
          pagination={{ clickable: true }}
          watchOverflow
        >
          {prodotti.map((p) => (
            <SwiperSlide key={p.pk}>
              <div className={styles.sliderItem}>
                <TabTriggerCard
                  label={p.titolo}
                  icon={getIcon(p.icon)}
                  onClick={() => setProdottoPreventivatoreModal(p)}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default PreventivatoreHomeSection
